function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import 'regenerator-runtime/runtime';
import Alpine from 'alpinejs';
import ScrollMagic from 'scrollmagic';
import { gsap, Power4 } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { breakpoint } from '../../../vendorjs/breakpoint-helper.vendor';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
export var menuSubnav = function menuSubnav() {
  Alpine.data('menuSubnav', function () {
    return {
      dispatcher: null,
      subNavIsOpen: true,
      stickyNavScrollTrigger: false,
      controller: false,
      activeAnchor: false,
      firstAnchor: false,
      scenes: [],
      sections: [],
      stickyScene: false,
      navOffset: {
        top: 0,
        bottom: 0,
        height: 0
      },
      linkActive: ('lg:text-blue-400', 'underline', 'lg:no-underline', 'border-blue-400'),
      adminToolbarHeight: 0,
      triggerOffset: 0,
      scrollSpeed: 0.75,
      init: function init() {
        this.subNavIsOpen = breakpoint.isDesktop;
        this.dispatcher = this.$dispatch;
        this.refresh();
      },
      refresh: function refresh() {
        var $element = this.$el;
        this.subNavIsOpen = breakpoint.isDesktop;
        this.navOffset = this.getElementDimensions($element);
        this.scenes = [];
        this.controllerInit();
        this.dispatcher('anchors');
        this.stickyNav();
        this.getFirstAnchor();
      },
      controllerInit: function controllerInit() {
        var _this = this;

        if (this.controller) {
          this.controller.destroy();
        }

        this.calculateOffset();
        this.controller = new ScrollMagic.Controller();
        this.controller.scrollTo(function (newPosition) {
          var $this = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this;
          gsap.to(window, {
            duration: $this.scrollSpeed,
            ease: Power4.easeInOut,
            scrollTo: {
              y: newPosition,
              offsetY: $this.triggerOffset + $this.navOffset.outerHeight
            }
          });
        });
      },
      stickyNav: function stickyNav() {
        if (this.stickyNavScrollTrigger) {
          this.stickyNavScrollTrigger.kill(true);
        }

        var $this = this;
        var $nav = this.$el;
        this.stickyNavScrollTrigger = ScrollTrigger.create({
          trigger: $nav,
          endTrigger: '.tlc__content',
          pin: true,
          pinSpacing: false,
          start: "top top+=".concat($this.triggerOffset),
          end: "bottom top+=".concat($this.triggerOffset + $this.navOffset.height),
          markers: false // Useful for debugging.

        });
        this.stickyNavScrollTrigger.refresh();
      },
      getFirstAnchor: function getFirstAnchor() {
        var firstLink = this.$el.querySelectorAll('a')[0];

        if (firstLink) {
          this.firstAnchor = firstLink.innerText;
        }
      },
      anchors: function anchors() {
        var _this2 = this;

        var href = this.$el.getAttribute('href');
        var triggerElement = document.querySelector(href);

        if (triggerElement) {
          var windowHeight = window.screen.height;
          var triggeringElementDimensions = this.getElementDimensions(triggerElement);
          var triggerHook = 1 - (windowHeight - (this.triggerOffset - this.navOffset.outerHeight)) / windowHeight;
          var linkScene = new ScrollMagic.Scene({
            triggerElement: triggerElement,
            triggerHook: triggerHook,
            duration: triggeringElementDimensions.outerHeight,
            offset: -(this.triggerOffset + this.navOffset.outerHeight + 3)
          }).addTo(this.controller);
          linkScene.on('enter', function (e) {
            var $this = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2;
            var linkElement = $this.$el;
            _this2.activeAnchor = linkElement;

            _this2.updateHistory(href);

            if (breakpoint.isDesktop) {
              linkElement.classList.add($this.linkActive);
            }
          });
          linkScene.on('leave destroy', function (e) {
            var $this = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this2;
            var linkElement = $this.$el;

            if (breakpoint.isDesktop) {
              linkElement.classList.remove($this.linkActive);
            }
          });
          this.scenes.push(linkScene);
          this.sections.push(href); // First scene only.

          if (this.scenes[0]) {
            this.scenes[0].on('leave', function (e) {
              if (e.scrollDirection === 'REVERSE') {
                // Clear anchor from url.
                _this2.updateHistory(' ');

                _this2.activeAnchor = false;
              }
            });
          }
        }
      },
      getElementDimensions: function getElementDimensions(element) {
        // Get the DOM Node if you pass in a string
        var $element = typeof element === 'string' ? document.querySelector(element) : element;

        var _$element$getBounding = $element.getBoundingClientRect(),
            top = _$element$getBounding.top,
            right = _$element$getBounding.right,
            bottom = _$element$getBounding.bottom,
            left = _$element$getBounding.left,
            width = _$element$getBounding.width,
            height = _$element$getBounding.height,
            x = _$element$getBounding.x,
            y = _$element$getBounding.y;

        var dimensions = {
          top: top,
          right: right,
          bottom: bottom,
          left: left,
          width: width,
          height: height,
          x: x,
          y: y
        };
        var styles = window.getComputedStyle($element);
        var marginTop = parseFloat(styles.marginTop);
        var marginBottom = parseFloat(styles.marginBottom);
        var marginY = marginTop + marginBottom;
        var outerHeight = Math.ceil(height + marginY);
        return _objectSpread(_objectSpread({}, dimensions), {}, {
          outerHeight: outerHeight,
          marginTop: marginTop,
          marginBottom: marginBottom,
          marginY: marginY
        });
      },
      toggleNav: function toggleNav() {
        this.subNavIsOpen = !(this.subNavIsOpen && !breakpoint.isDesktop);
      },
      updateHistory: function updateHistory(id) {
        if (window.history && window.history.replaceState) {
          window.history.replaceState('', document.title, id);
        }
      },
      hashChanged: function hashChanged() {
        if (window.location.hash) {
          var anchor = window.location.hash;
          var element = document.querySelector(anchor);

          if (element) {
            this.controller.scrollTo(anchor);
          }
        }
      },
      calculateOffset: function calculateOffset() {
        this.triggerOffset = 0;
        var adminToolbar = document.querySelector('#gin-toolbar-bar');

        if (adminToolbar) {
          var adminToolbarDimensions = this.getElementDimensions(adminToolbar);
          this.adminToolbarHeight = adminToolbarDimensions.outerHeight;
          this.triggerOffset += this.adminToolbarHeight;
        }
      },
      subnav: {
        // eslint-disable-next-line func-names
        '@resize.window.stop.debounce.200ms': function resizeWindowStopDebounce200ms() {
          this.refresh();
        },
        // eslint-disable-next-line func-names
        '@load.window': function loadWindow() {
          this.refresh();
        }
      },
      subnavMenu: {
        // eslint-disable-next-line func-names
        'x-show': function xShow() {
          return this.subNavIsOpen;
        },
        // eslint-disable-next-line func-names
        'x-transition:enter-start': function xTransitionEnterStart() {
          return 'opacity-0 scale-115 -translate-y-1/2 bg-grey-100';
        },
        // eslint-disable-next-line func-names
        'x-transition:enter-end': function xTransitionEnterEnd() {
          return 'opacity-100';
        },
        // eslint-disable-next-line func-names
        'x-transition:leave-start': function xTransitionLeaveStart() {
          return 'opacity-100 bg-grey-100';
        },
        // eslint-disable-next-line func-names
        'x-transition:leave-end': function xTransitionLeaveEnd() {
          return 'opacity-0 scale-115 -translate-y-3/4';
        }
      },
      toggle: {
        // eslint-disable-next-line func-names
        '@click': function click() {
          this.toggleNav();
        }
      },
      anchor: {
        // eslint-disable-next-line func-names
        '@anchors.window': function anchorsWindow() {
          this.anchors();
        },
        // eslint-disable-next-line func-names
        '@click.prevent': function clickPrevent() {
          var href = this.$el.getAttribute('href');
          var element = document.querySelector(href);

          if (element) {
            this.controller.scrollTo(href);
            this.updateHistory(href);
          }
        }
      },
      nextLink: {
        // eslint-disable-next-line func-names
        '@click': function click() {
          if (breakpoint.isTouch) {
            if (this.sections[0] && !this.activeAnchor) {
              var firstScene = this.sections[0];
              var element = document.querySelector(firstScene);

              if (element) {
                this.controller.scrollTo(firstScene);
              }
            } else {
              this.toggleNav();
            }
          }
        }
      }
    };
  });
};